export default {
  header: 'Importovať významy',
  selectFile: {
    placeholder: 'Vybrať zdroj',
    selected: 'Zdroj',
  },
  verifyMapping: {
    headline: 'Skontrolovať vlastnosti',
    selectAttributes: 'Vlastnosti na importovanie',
    doImport: 'Importovať vybrané významy',
  },
  migrateProgress: {
    headline: 'Importovať významy',
  },
  warning: {
    text: 'Zmeny vykonané počas migrácie sú nezvratné. Odporúča sa vopred stiahnuť zálohu vlastných významov. Túto zálohu je možné neskôr importovať na obnovenie aktuálneho stavu',
    downloadBackup: 'Stiahnuť zálohu',
  },
  next: 'Ďalší',
  prev: 'Predchádzajúci',
};
